// removed by extract-text-webpack-plugin
module.exports = {"list":"list-VEQ8D","none":"none-3ACkh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lists/list/list.less
 ** module id = 177
 ** module chunks = 0
 **/